module.exports = __webpack_public_path__ + "img/borrower-card-bg.a0853ad.png";